<template>
    <div>
        <div v-if="examId != null">
            <div class="row mb-3">

                <div class="col-md-10 d-flex align-items-center">
                    <b-button variant="outline-secondary" class="btn-sm mr-3" @click="backPage"><i
                            class="ri-arrow-left-line" style="font-size: 30px;"></i>
                    </b-button>
                    <span class="exam mr-2">{{ $t('questions') }}</span>|<span class="course mx-2">
                        {{ courseName }}
                    </span>-<span class="exam-type ml-2">
                        {{ examTypeText }} {{ exam_date ? `- ${this.$moment(exam_date).format("DD/MM/YYYY")}` : '' }}
                    </span>
                </div>
                <div class="col-md-2 d-flex justify-content-end">
                    <b-button class="mt-3 mt-md-0"
                        variant="success" @click="addQuestions" v-if="checkPermission('examquestion_storebyexam')"><i class="ri-add-line mr-1"></i>
                        {{ $t('new') }}
                    </b-button>
                </div>
            </div>
        </div>
        <div>
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                :title="null" :show-paginate="false" :queryParams="datatable.queryParams" :lineNumbers="false"
                v-show="datatable.showTable">

            </datatable>
            <CommonModal ref="createForm" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()">
                <template v-slot:CommonModalTitle>
                    {{ $t('create') }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-update-form v-if="formProgress" :courseId="courseId" :examExamId="examExamId" :updateData="updateData" @successForm="successForm" />
                </template>
            </CommonModal>
        </div>
    </div>
</template>
<script >
//Pages
import CreateUpdateForm from "@/modules/examDefinitions/pages/ExamQuestions/CreateUpdateForm"
//Services
import ExamQuestionsService from "@/services/ExamQuestionsService"

export default {
    components: {
        CreateUpdateForm
    },
    props: {
        examId: {
            type: Number
        },
        examExamId: {
          type: Number
        },
        examTypeText: {
            type: String
        },
        courseName: {
            type: String
        },
        section_id: {
            type: Number
        },
        numberOfExams: {
            type: Number
        },
        threshold_value: {
            type: Number
        },
        courseId: {
            type: Number,
        }
    },
    data() {
        return {
            showExam: false,
            form: {},
            exam_id: null,
            exam_date: null,
            is_finalized: false,
            published_at : null,
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('edit'),
                                class: 'ri-edit-box-line',
                                permission: 'examquestion_updatebyexam',
                                callback: (row) => {
                                    this.updateExams(row);
                                }
                            },
                            {
                                text: this.$t('delete'),
                                class: 'ri-delete-bin-2-line',
                                permission: 'examquestion_deletebyexam',
                                callback: (row) => {
                                    this.formDelete(row.id);
                                }
                            },
                        ]
                    },
                    {
                        label: this.$t('id'),
                        field: 'id',
                        sortable: false,
                        hidden: true
                    },
                    {
                        label: this.$t('question'),
                        field: 'question',
                        sortable: false,
                    },
                    {
                        label: this.$t('score'),
                        field: 'point',
                        sortable: false,
                    },
                    {
                        label: this.$t('course_outcomes'),
                        field: 'course_outcomes',
                        sortable: false,
                        formatFn: (row) => {
                            let result = ''
                            row.forEach(item => {
                                result += '+ '+this.getLocaleText(item.course_outcome, 'name')+'<br>'
                            })
                            return result
                        }
                    }
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: true,
                queryParams: {
                    filter: {},
                    sort: '-id',
                    page: 1,
                    limit: 20
                }
            },
            errors: [],
            students: [],
            fieldNote: [
                { key: 'student_number', label: this.toUpperCase('student_number'), sortable: true },
                { key: 'name', label: this.toUpperCase('name'), sortable: true },
                {
                    label: this.$t('program_name'),
                    key: 'program_name',
                },
                { key: 'score', label: this.toUpperCase('exam_score'), sortable: true },
                { key: 'attended', label: this.toUpperCase('attended'), sortable: true }
            ],
            formProgress: null,
            formId: null,
            updateData: null,
        }
    },
    watch: {
        examId: {
            handler(newValue) {
                this.getRows(newValue)
            }
        }
    },
    created() {
        this.getRows(this.examExamId)
    },
    methods: {
        formClear() {
            this.formProgress = null
            this.updateData = null
        },

        getRows(value) {
            ExamQuestionsService.getAllById(value).then(response => {
                    this.datatable.rows = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        formDelete(id) {
            this.$swal.fire({
                text: this.$t('are_you_sure_to_delete'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no'),
            }).then((result) => {
                if (result.isConfirmed) {
                    ExamQuestionsService.del(id).then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message))
                        this.getRows(this.examExamId)
                        this.formClear()
                    }).catch(error => {
                        this.$toast.error(this.$t('api.' + error.data.message))
                    })
                }
            })
        },
        addQuestions() {
            this.formProgress = 'create'
            this.$refs.createForm.$refs.commonModal.show()
        },
        successForm() {
            this.formClear()
            this.formProgress = null
            this.$refs.createForm.$refs.commonModal.hide()
            this.getRows(this.examExamId)
        },
        updateExams(row) {
            this.updateData = row
            this.formProgress = 'update'
            this.$refs.createForm.$refs.commonModal.show()
        },
        successUpdateForm() {
            this.formClear()
            this.$refs.updateForm.$refs.commonModal.hide();
            this.getRows(this.examId)
        },
        backPage() {
            this.$emit('tableStatusUpdate', 'exam')
        },
    },
}
</script>
<style>
.table-custom-btn {
    width: 100%;
    min-height: 40px;
}

.exam {
    font-size: 20px;
    color: black;
}

.course {
    font-size: 16px;
}

.exam-type {
    font-size: 16px;
}

.icon {
    font-size: 16px;
}
</style>
